import { apiClient } from "../api/apiClient";

import {
  ApiResponse,
  FAQ,
  CreateFAQRequest,
  UpdateFAQRequest
} from "../interfaces/FAQ";

// ======================================
// FAQ SERVICE
// ======================================

export const faqService = {

  // ======================================
  // GET ALL
  // ======================================

  getAll: async (): Promise<FAQ[]> => {

    const response =
  await apiClient.get<
    ApiResponse<FAQ>
  >(
    "/FAQs/GetAll"
  );

    const result =
      response.data;

    console.log(
      "FAQ Data List:",
      result.dataList
    );

    if (!result.isSuccess) {

      throw new Error(
        result.message
      );
    }

    return result.dataList || [];
  },

  // ======================================
  // GET ACTIVE ALL
  // ======================================

  getActiveAll: async (): Promise<FAQ[]> => {

   
      const response =
  await apiClient.get<
    ApiResponse<FAQ>
  >(
    "/FAQs/GetActiveAll"
  );

    const result =
      response.data;

    if (!result.isSuccess) {

      throw new Error(
        result.message
      );
    }

    return result.dataList || [];
  },

  // ======================================
  // GET BY ID
  // ======================================

  getById: async (
    id: number
  ): Promise<FAQ> => {

    const response =
      await apiClient.get<
        ApiResponse<FAQ>
      >(
        `/FAQs/${id}`
      );

    const result =
      response.data;

    if (!result.isSuccess) {

      throw new Error(
        result.message
      );
    }

    if (!result.data) {

      throw new Error(
        "FAQ not found"
      );
    }

    return result.data;
  },

  // ======================================
  // CREATE
  // ======================================

  create: async (
    payload: CreateFAQRequest
  ) => {

    const formData =
      new FormData();

    formData.append(
      "Question",
      payload.question
    );

    formData.append(
      "Answer",
      payload.answer
    );

    formData.append(
      "FAQCategoryID",
      payload.faqCategoryID?.toString() || ""
    );

    formData.append(
      "DisplayOrder",
      payload.displayOrder?.toString() || "0"
    );

    formData.append(
      "Status",
      payload.status || "active"
    );

    formData.append(
      "IsActive",
      payload.isActive.toString()
    );

    // SEO

    formData.append(
      "MetaTitle",
      payload.metaTitle || ""
    );

    formData.append(
      "MetaDescription",
      payload.metaDescription || ""
    );

    formData.append(
      "MetaKeywords",
      payload.metaKeywords || ""
    );

    formData.append(
      "CanonicalUrl",
      payload.canonicalUrl || ""
    );

    // OG

    formData.append(
      "OgTitle",
      payload.ogTitle || ""
    );

    formData.append(
      "OgDescription",
      payload.ogDescription || ""
    );

    formData.append(
      "OgImage",
      payload.ogImage || ""
    );

    formData.append(
      "SchemaMarkup",
      payload.schemaMarkup || ""
    );

    const response =
      await apiClient.post(
        "/FAQs/Create",
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

    return response.data;
  },

  // ======================================
  // UPDATE
  // ======================================

  update: async (
    payload: UpdateFAQRequest
  ) => {

    const formData =
      new FormData();

    formData.append(
      "FAQID",
      payload.faqID.toString()
    );

    formData.append(
      "Question",
      payload.question
    );

    formData.append(
      "Answer",
      payload.answer
    );

    formData.append(
      "FAQCategoryID",
      payload.faqCategoryID?.toString() || ""
    );

    formData.append(
      "DisplayOrder",
      payload.displayOrder?.toString() || "0"
    );

    formData.append(
      "Status",
      payload.status || "active"
    );

    formData.append(
      "IsActive",
      payload.isActive.toString()
    );

    // SEO

    formData.append(
      "MetaTitle",
      payload.metaTitle || ""
    );

    formData.append(
      "MetaDescription",
      payload.metaDescription || ""
    );

    formData.append(
      "MetaKeywords",
      payload.metaKeywords || ""
    );

    formData.append(
      "CanonicalUrl",
      payload.canonicalUrl || ""
    );

    // OG

    formData.append(
      "OgTitle",
      payload.ogTitle || ""
    );

    formData.append(
      "OgDescription",
      payload.ogDescription || ""
    );

    formData.append(
      "OgImage",
      payload.ogImage || ""
    );

    formData.append(
      "SchemaMarkup",
      payload.schemaMarkup || ""
    );

    const response =
      await apiClient.put(
        "/FAQs/Update",
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

    return response.data;
  },

  // ======================================
  // DELETE
  // ======================================

  delete: async (
    id: number
  ) => {

    const response =
      await apiClient.delete(
        `/FAQs/${id}`
      );

    return response.data;
  }
};